export const SET_DELIVERY_CONFIGURACAO = "SET_DELIVERY_CONFIGURACAO";
export const SET_LOADING_DELIVERY_CONFIGURACAO =
  "SET_LOADING_DELIVERY_CONFIGURACAO";
